// extracted by mini-css-extract-plugin
export var validationError = "HMIf0tvzcV5_LlgWNXNw";